var _desc, _g;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgCheckCal(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "16px",
    height: "16px",
    viewBox: "0 0 16 16",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Group 22") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Symbols",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-22"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    fill: "#00A0AD",
    cx: 8,
    cy: 8,
    r: 8
  }), /*#__PURE__*/React.createElement("g", {
    id: "Check-Cal",
    transform: "translate(3.700000, 3.000000)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fill: "#FFFFFF",
    x: 0,
    y: 1,
    width: 8.5,
    height: 8,
    rx: 1
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fill: "#00A0AD",
    x: 5.5,
    y: 0,
    width: 2,
    height: 2,
    rx: 0.5
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fill: "#00A0AD",
    x: 0.7,
    y: 0,
    width: 2,
    height: 2,
    rx: 0.5
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fill: "#FFFFFF",
    x: 1.1,
    y: 0.2,
    width: 1.1,
    height: 1.5,
    rx: 0.5
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fill: "#FFFFFF",
    x: 6,
    y: 0.2,
    width: 1.1,
    height: 1.5,
    rx: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    fill: "#00A0AD",
    cx: 4.3,
    cy: 5,
    r: 2.5
  }), /*#__PURE__*/React.createElement("g", {
    id: "icons/16px/check",
    transform: "translate(2.600000, 3.000000)",
    fill: "#FFFFFF",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2.96422455,0.887867965 C3.07306477,0.770710678 3.24952962,0.770710678 3.35836984,0.887867965 C3.46721005,1.00502525 3.46721005,1.19497474 3.35836984,1.31213203 L1.68615302,3.11213202 C1.57678804,3.22985417 1.3992868,3.22920324 1.29066953,3.11068171 L0.320291996,2.05182029 C0.212195905,1.93386746 0.213398271,1.74392238 0.322977557,1.62756608 C0.432556842,1.51120978 0.6090176,1.51250402 0.717113691,1.63045686 L1.49042776,2.47428558 L2.96422455,0.887867965 Z",
    id: "Path-2"
  })))))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckCal);
export default __webpack_public_path__ + "static/media/CheckCal_.efc1b30c2be29157db807f15c232b6f9.svg";
export { ForwardRef as ReactComponent };